const { find } = require("lodash");

$(document).ready(function(){
    
    $('#collapseViolating li.active').parent().parent().toggleClass("show");


    $(".scroll-link").on("click", function (event) {
        event.preventDefault();
        var id  = $(this).attr('href'),
        //узнаем высоту от начала страницы до блока на который ссылается якорь
            top = $(id).offset().top;

        //анимируем переход на расстояние - top за 1500 мс
        $('body,html').animate({scrollTop: top}, 1500);
    });

    $('#dataTable').DataTable({
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.12/i18n/Ukrainian.json"
        },
    });
});
